import Clickoutside from "./clickoutside";
import Focus from "./focus";

export default {
  install(vue) {
    vue.directive("outsideclick", Clickoutside);
    vue.directive("focus", Focus);
  },
};
